




















































import { requiredRule } from "@/lib/rules/requiredRule";
import { IRepairDetails, RepairDetails } from "@/models/repair.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";
import CompanySelection from "../contact/CompanySelection.vue";
import { RepairStatusEnum } from "@/lib/enum/repair.enum";

@Component({
  components: { CompanySelection },
  filters: {}
})
export default class RepairDetailForm extends Vue {
  ResourceEnum = ResourceEnum;
  RepairStatusEnum = RepairStatusEnum;

  @Prop({ default: new RepairDetails() })
  value!: IRepairDetails;

  get required() {
    return [requiredRule()];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get endDateRules() {
    return [
      requiredRule(),
      (value: string) => {
        if (!value || !this.value?.startDateFormable) return true;

        const startDate = new Date(this.value.startDateFormable);
        const endDate = new Date(value);

        return endDate >= startDate || this.$t("objects.clearance.repairEndValidation").toString();
      }
    ];
  }
}
